/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Segment_Start_LabelInputs */

const en_ad_segment_start_label = /** @type {(inputs: Ad_Segment_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Timecode`)
};

const fr_ad_segment_start_label = /** @type {(inputs: Ad_Segment_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code temporel de début`)
};

const de_ad_segment_start_label = /** @type {(inputs: Ad_Segment_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Startzeitcode`)
};

const it_ad_segment_start_label = /** @type {(inputs: Ad_Segment_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codice temporale di inizio`)
};

const ru_ad_segment_start_label = /** @type {(inputs: Ad_Segment_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начальный временной код`)
};

const es_ad_segment_start_label = /** @type {(inputs: Ad_Segment_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de tiempo de inicio`)
};

const zh_cn2_ad_segment_start_label = /** @type {(inputs: Ad_Segment_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始时间码`)
};

const ja_ad_segment_start_label = /** @type {(inputs: Ad_Segment_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始タイムコード`)
};

const hi_ad_segment_start_label = /** @type {(inputs: Ad_Segment_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रारंभ समयकोड`)
};

const pt_pt2_ad_segment_start_label = /** @type {(inputs: Ad_Segment_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de tempo inicial`)
};

/**
* | output |
* | --- |
* | "Start Timecode" |
*
* @param {Ad_Segment_Start_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_segment_start_label = /** @type {((inputs?: Ad_Segment_Start_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Segment_Start_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_segment_start_label(inputs)
	if (locale === "de") return de_ad_segment_start_label(inputs)
	if (locale === "it") return it_ad_segment_start_label(inputs)
	if (locale === "ru") return ru_ad_segment_start_label(inputs)
	if (locale === "es") return es_ad_segment_start_label(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_segment_start_label(inputs)
	if (locale === "ja") return ja_ad_segment_start_label(inputs)
	if (locale === "hi") return hi_ad_segment_start_label(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_segment_start_label(inputs)
	return en_ad_segment_start_label(inputs)
});